namespace Recommendations  {

    export interface ITrackRecommendedHotelGroups {
        trackView(tab): void;
        trackClick(tab, hotel): void;
        __bd4reco(tab, hotel): string;
    }

    function RecommenderTracker (
        searchUnitService: SearchUnitService,
        bd4t: any,
        $q: ng.IQService,
        analytics: any
    )
    {
        function appendHotelTracking(promise) {
            return promise
                .then(({ hotels, placementId, token }) => ({
                    hotels,
                    trackView: trackView(placementId, hotels, token),
                    trackClick: trackClick(placementId, token)
                }))
                .catch(() => $q.resolve({
                    hotels: [],
                    trackView: angular.noop,
                    trackClick: angular.noop
                }));
        }

        function appendDestinationTracking(promise) {
            return promise
                .then(({ destinations, placementId, token }) => ({
                    destinations,
                    trackView: trackView(placementId, destinations, token),
                    trackClick: trackClick(placementId, token)
                }))
                .catch(() => $q.resolve({
                    destinations: [],
                    trackView: angular.noop,
                    trackClick: angular.noop
                }));
        }

        function trackView(placementId, hotels, ptoken) {
            if (!_.isUndefined(hotels) && !_.isEmpty(hotels)) {
                analytics.track(
                    'mixpanel',
                    'RecommenderLoaded',
                    {
                        placement: placementId,
                        estabIds: _.map(hotels, (h:any) => h.Id),
                        prices: _.map(hotels, (h:any) => h.IndicativeMinPrice),
                        ShortTitleLookedFor: _.get(searchUnitService.getDestination(), 'Title')
                    }
                );
            }

            return (listOffset, listPreviousOffset, pageSize, elements) => {
                bd4t('send', 'recoview', {
                    listId: placementId,
                    ptoken,
                    listOffset,
                    listPreviousOffset,
                    pageSize,
                    total: _.size(hotels),
                    elements: _.map(elements, (e:any) => (
                        { id: e.Id.toString(), prices: { default: e.PricePerPerson, total: e.TotalPrice } }
                    ))
                });
            };
        }

        function trackClick(placement, ptoken) {
            return (hotel: any, pageSize: number) => {
                bd4t('send', 'engagement', {
                    listId: placement,
                    ptoken,
                    listPosition: hotel.Position % pageSize,
                    listOffset: pageSize * Math.round(hotel.Position / pageSize),
                    medium: 'recommender-card',
                    type: 'reco:selection',
                    element: { id: hotel.Id, prices: { default: hotel.PricePerPerson, total: hotel.TotalPrice } }
                });

                analytics.track(
                    'mixpanel',
                    'RecommenderClicked',
                    {
                        placement: placement,
                        position: hotel.Position,
                        estabId: hotel.Id,
                        price: hotel.IndicativeMinPrice,
                        ShortTitleLookedFor: _.get(searchUnitService.getDestination(), 'Title'),
                        ShortTitleClicked: `${hotel.Province}, ${hotel.Country}`
                    }
                );
            };
        }

        function trackRecommendedHotelGroupsFactory(allTabItems): ITrackRecommendedHotelGroups {
            const listId = 'recommended_hotel_groups';
            let groups = _.map(allTabItems, (tab: any) => {
                return tab.GroupId =  tab.Title.toLowerCase().replace(/\s+/g, '-');
            });
            let previousGroupId;
            function mapHotelToBd4Format(hotel) {
                return { id: hotel.Id, prices: { 'hotel.pp': hotel.IndicativeMinPrice, }, };
            };
            return {
                trackView: (tab) => {
                    bd4t('send', 'recoview', {
                        listId,
                        ptoken: tab.RankingScoresToken,
                        listOffset: 0,
                        listPreviousOffset: 0,
                        pageSize: tab.Hotels.length,
                        total: tab.Hotels.length,
                        elements: _.map(tab.Hotels, mapHotelToBd4Format),
                        groupId: tab.GroupId,
                        title: tab.Title,
                        groups,
                        previousGroupId,
                    });
                    previousGroupId = tab.GroupId;
                },
                trackClick: (tab, hotel) => {
                    bd4t('send', 'engagement', {
                        type: 'reco:selection',
                        listId,
                        ptoken: tab.RankingScoresToken,
                        listPosition: hotel.HotelIndex - 1,
                        listOffset: 0,
                        element: mapHotelToBd4Format(hotel),
                        groupId: tab.GroupId,
                        title: tab.Title,
                        groups,
                    });
                },
                __bd4reco: (tab, hotel) => {
                    let experimentBucket = '';
                    let absolutePosition = hotel.HotelIndex - 1;
                    return `${listId}|${experimentBucket}|${absolutePosition}|${tab.ptoken}`;
                },
            };
        }

        return {
            appendHotelTracking,
            appendDestinationTracking,
            trackRecommendedHotelGroupsFactory,
        };
    }

    angular
        .module('recommendations')
        .service('recommenderTracker', RecommenderTracker);
}
